export default __webpack_public_path__ + "static/media/PSQL.c1c6b0b4.jpg";